export default {
  title: 'หนังสือรับรองออนไลน์',
  form: {
    employeeCode: {
      label: 'รหัสพนักงานที่ขอเอกสารให้',
      placeholder: 'ระบุรหัสพนักงานในบริษัทปัจจุบัน',
      hint: 'เว้นว่างเพื่อขอเอกสารให้ตัวเอง'
    },
    certificateType: {
      label: 'ประเภทหนังสือรับรอง',
      placeholder: 'ประเภทหนังสือรับรอง'
    }
  },
  button: {
    request: 'ขอหนังสือรับรอง',
    submit: 'ขอหนังสือรับรอง',
    print: 'พิมพ์หนังสือรับรอง'
  }
}
